import { createRoute } from "@tanstack/react-router";

import { firstAdSearch } from "../../platform/first-ad-choice";
import { rootRoute } from "../../platform/routes";
import { FreeAdLanding } from "./FreeAdLanding";

export const freeAdRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/start/free",
  staticData: { public: true },
  validateSearch: (search) => firstAdSearch.parse(search),
  component: FreeAdLanding,
});
